import { Loader2 } from "lucide-react";

const AppLoading = () => {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4">
      <div className="relative">
        <div className="w-12 h-12 rounded-full border-4 border-gray-100 dark:border-gray-800" />
        <Loader2 size={48} className="absolute inset-0 text-primaryColor animate-spin" />
      </div>
      <div className="text-center">
        <p className="text-sm font-semibold text-gray-700 dark:text-gray-300">Loading</p>
        <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">Please wait a moment</p>
      </div>
    </div>
  );
};

export default AppLoading;
